import { observer } from 'mobx-react';
import { ReactNode } from 'react';

import AppState from '../AppState';
import { RequestQuoteConfirmation } from '../requestQuote/RequestQuoteConfirmation';
import RequestQuoteSteps from '../requestQuote/RequestQuoteSteps/RequestQuoteSteps';
import NavButton from '../shared/components/Button/NavButton';
import HeaderLevel1 from '../shared/components/Typography/HeaderLevel1';
import { HubSpotFormPage } from '../shared/hubSpot/HubSpotFormPage';
import ModularConfigurationSummary from './components/ModularConfigurationSummary';
import css from './ModularConfigurationRequestQuotePage.css';
import { ModularConfigurationRequestQuotePageState } from './ModularConfigurationRequestQuotePageState';

@observer
class ModularConfigurationRequestQuotePage extends HubSpotFormPage<ModularConfigurationRequestQuotePageState> {
  get initialFormData() {
    const data: Record<string, string> = {};

    if (this.props.state.configurationCode) {
      const { configurationCode, shopUrl, facilityId, facilityName } = this.props.state;

      data.latest_configuration_id = configurationCode;
      data.latest_configuration_url = shopUrl;
      data.latest_configuration_production_site_id = facilityId;
      data.latest_configuration_production_site_name = facilityName;
    } else {
      data.latest_configuration_id = 'na';
      data.latest_configuration_url = 'na';
      data.latest_configuration_production_site_id = 'na';
      data.latest_configuration_production_site_name = 'na';
    }

    data.latest_configuration_product_id = this.props.state.layoutId || this.props.state.productFamilyId;
    data.latest_configuration_brand = this.props.state.brand;
    data.price_quote_request = true.toString();

    return data;
  }

  public render() {
    const { appState, state } = this.props;
    const requestQuotePageTranslation = appState.translation.requestQuotePage;
    const translation = state.isRequestProcessedByDealer
      ? requestQuotePageTranslation.contentWhenProcessedByDealer
      : requestQuotePageTranslation.defaultContent;

    if (state.isFormSubmitted) {
      return (
        <RequestQuoteConfirmation
          isEmbedded={state.isEmbedded}
          navigation={appState.navigationState}
          translation={translation.confirmation}
        />
      );
    }

    return (
      <article>
        {!state.isEmbedded && (
          <NavButton className={css.navigation} onClick={state.backToSummary} back>
            {translation.goBackLink}
          </NavButton>
        )}
        <HeaderLevel1 className="visuallyHidden">{translation.title}</HeaderLevel1>
        {state.isRequestProcessedByDealer ? (
          <>
            <RequestQuoteSteps className={css.steps} translation={translation} />
            <RequestQuoteMainContent appState={appState} state={state}>
              {this.props.appState.store.canRequestQuote() ? super.render() : null}
            </RequestQuoteMainContent>
          </>
        ) : (
          <>
            <RequestQuoteMainContent appState={appState} state={state}>
              {this.props.appState.store.canRequestQuote() ? super.render() : null}
            </RequestQuoteMainContent>
            <RequestQuoteSteps className={css.steps} translation={translation} />
          </>
        )}
      </article>
    );
  }
}

export default ModularConfigurationRequestQuotePage;

interface RequestQuoteMainContentProps {
  appState: AppState;
  children: ReactNode;
  state: ModularConfigurationRequestQuotePageState;
}

function RequestQuoteMainContent({ appState, children, state }: RequestQuoteMainContentProps) {
  return (
    <div className={css.container}>
      <div className={css.formContainer} id="hsRequestQuoteForm">
        {children}
      </div>
      <ModularConfigurationSummary
        className={css.summary}
        productFamilyName={state.productName}
        components={state.components}
        configurationCode={state.configurationCode}
        translation={appState.translation.cart.summary}
      />
    </div>
  );
}
